// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1tZl7","content":"LoadingAlert_content__3ZMeB"};